import styled from "styled-components"
import constants from "~/style/constants"

const Input = styled.input`
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-appearance: none;
  border: 1px solid
    ${(props) =>
      props.error ? props.theme.colors.error : constants.colors.ui.borderGray};
  border-radius: 4px;
  outline: none;
  height: 70px;
  width: 100%;
  max-width: ${(props) => props.maxWidth || "364px"};
  font-family: ${(props) => props.theme.fonts.avenirNextRegular};
  font-size: 1rem;
  text-indent: 20px;
  color: ${(props) => props.theme.colors.text.input};
  &::placeholder {
    color: ${(props) => props.theme.colors.text.inputPlaceholder};
  }
  caret-color: ${(props) => props.theme.colors.primary};
  box-shadow: 0px 8px 15px 0px rgba(35, 41, 48, 0.15);

  @media (max-width: 768px) {
    height: 56px;
    font-size: 0.9rem;
    max-width: 100%;
  }

  @media (max-width: 480px) {
    height: 48px;
    font-size: 0.85rem;
    text-indent: 16px;
  }
`

export default Input
